<template>
  <div class="quner-error-wrapper">
    <img class="error-img" src="//s.qunarzz.com/bnb_hy2/images/unlogin.png" alt>
    <p class="error-title">活动已过期，下次早点来哦~</p>
    <p class="error-text">
      <span style="color: rgb(94,174,205)">3</span>秒后自动跳转至去哪儿民宿
    </p>
  </div>
</template>

<script>
import { Sniff } from '@/utils/q_sniff'
export default {
  created() {
    const { protocol, host } = window.location
    const url = `${protocol}//${host}/tjbnb/app/index.jsp?#/home`
    setTimeout(() => {
      if (Sniff.miniprogram) {
        window.wx && wx.miniProgram.navigateBack({
          delta: 1
        })
        return
      }
      if (this.platform === 5) {
        const hysdk = window.hysdk
        hysdk.closeWebView()
        return
      }
      location.replace(url)
    }, 3000)
  }
}
</script>

<style lang="scss" scoped>
.quner-error-wrapper {
  text-align: center;
  padding-top: 160px;
  .error-img {
    transform: scale(1.4);
  }
  .error-title {
    margin: 0;
    padding-top: 60px;
    font-size: 20px;
  }
  .error-text {
    margin: 0;
    padding-top: 15px;
    font-size: 16px;
    color: #666;
  }
}
</style>
